import {OrderStatusList, StateOrderStatusList} from '../../../../model/order-status-list.model';
import {createFeatureSelector, createSelector, MemoizedSelector} from '@ngrx/store';
import {StateUtils} from '@spartacus/core';
import {LoaderState} from '../../../state/utils/loader/loader-state';

export const USER_ORDER_STATUS_FEATURE = 'userOrderStatus';

export interface StateWithOrderStatusList {
  [USER_ORDER_STATUS_FEATURE]: StateOrderStatusList;
}

export const getOrderStatusListState: MemoizedSelector<StateWithOrderStatusList, StateOrderStatusList> =
  createFeatureSelector<StateOrderStatusList>(USER_ORDER_STATUS_FEATURE);

export const getOrderStatusListLoaderState: MemoizedSelector<StateWithOrderStatusList,
  LoaderState<OrderStatusList>> = createSelector(getOrderStatusListState, (state: StateOrderStatusList) => state.entities);

export const getOrderStatusList: MemoizedSelector<StateWithOrderStatusList,
  OrderStatusList> = createSelector(getOrderStatusListLoaderState, (state: LoaderState<OrderStatusList>) =>
  StateUtils.loaderValueSelector(state)
);

export const getOrderStatusListLoading: MemoizedSelector<StateWithOrderStatusList,
  boolean> = createSelector(getOrderStatusListLoaderState, (state: LoaderState<OrderStatusList>) =>
  StateUtils.loaderLoadingSelector(state)
);

export const getOrderStatusListLoaded: MemoizedSelector<StateWithOrderStatusList,
  boolean> = createSelector(getOrderStatusListLoaderState, (state: LoaderState<OrderStatusList>) =>
  StateUtils.loaderSuccessSelector(state)
);
